import { createContext } from 'react';
import * as Dfns from 'date-fns/fp';
import { OrderViewContextValue, SubFlight } from './streaming-buying-types';

const DATE_FORMAT = 'yyyy-MM-dd';
const PRETTY_DATE_FORMAT = 'M/d/yyyy';
const TODAY = Dfns.format(DATE_FORMAT, new Date());

export const OrderViewContext = createContext<OrderViewContextValue>({} as OrderViewContextValue);

export const toPrettyDate = (date: string): string =>
  Dfns.format(PRETTY_DATE_FORMAT, Dfns.parseISO(date));

export const toPrettySpendWithCents = (spend: number | undefined): string =>
  (spend || 0).toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD'
  });

export const toPrettyImpressions = (impressions: number | undefined): string =>
  (impressions || 0).toLocaleString('en-US');

export const subFlightsToPropertyArray = (subFlights: SubFlight[] | undefined): string[] => {
  const active = (subFlights ?? []).filter(
    el => !el.ending && !el.zeroLength && (!el.endDate || el.endDate >= TODAY)
  );
  return [...new Set(active.map(el => el.shortCode))].sort();
};

export const subFlightsToPropertyList = (subFlights: SubFlight[] | undefined): string =>
  subFlightsToPropertyArray(subFlights).join(', ');

export const resolvePDFText = (
  localText: string | undefined,
  orderText: string | undefined,
  defaultText: string
): string => localText ?? orderText ?? defaultText;

// Functional updates receive the text the user sees, not only the local edit, so that
// blurring the box with no edit does not replace the saved text with ''. An update that
// leaves the displayed text unchanged, or only trims it, does not create a local edit.
export const nextLocalPDFText = (
  update: string | ((prev: string) => string),
  localText: string | undefined,
  displayedText: string
): string | undefined => {
  if (!(update instanceof Function)) return update;
  const next = update(displayedText);
  const isNoOp = next === displayedText || next === displayedText.trim();
  return localText == null && isNoOp ? undefined : next;
};
